import React from "react";
import {
  Heart,
  Stethoscope,
  Utensils,
  Dumbbell,
  Brain,
  Car,
  Home,
  Shield,
  Users,
  Calendar,
  Pill,
  Bath,
} from "lucide-react";

const ServicesPage: React.FC = () => {
  const services = [
    {
      icon: Heart,
      title: "Personal Care Services",
      description:
        "Assistance with daily activities including bathing, dressing, grooming, and personal hygiene.",
      features: [
        "Room and Board",
        "A physically safe and sanitary environment",
        "24-hour round-the-clock direct care-staff assistance and supervision",
        "Assistance with all activities of daily living (ADLs), including bathing, dressing, grooming, toileting, and mobility",
        "All housekeeping, laundry services, Transportation, and In-home IT services",
        "Wellness assessments and health monitoring on global needs and requests",
        "Encouragement of independence while offering assistance as needed",
        "Consistent, structured daily routines to reduce anxiety and promote comfort",
      ],
    },
    {
      icon: Stethoscope,
      title: "Healthcare Management",
      description:
        "24/7 medical support with registered nurses and coordination with personal physicians.",
      features: [
        "Care planning with POA and Physicians, with every aspect followed by facility staff",
        "Pharmacy coordination with Medication and incontinence supply delivery",
        "Medication administration in accordance with physician orders",
        "In-home visits from physicians, PAs, and nurse practitioners",
        "Risk management for hydration, UTI prevention, fall prevention, pressure sores, mobility, nutrition, and dementia-related behaviors",
      ],
    },
    {
      icon: Utensils,
      title: "Nutritious Dining",
      description:
        "Home-cooked meals with dietary accommodations and 24/7 dining options.",
      features: [
        "Approved by a nutritionist. Three fresh home-cooked meals and healthy snacks that are both nutritional and balanced",
        "Almond Tree adheres to and accommodates the dietary needs tailored to different health conditions directed by residents' physicians",
        "Comfortable, family-style dining environment to encourage social interaction",
        "Hydration programs to promote adequate fluid intake throughout the day",
        "Special Occasion, seasonal, and culturally diverse meal options",
      ],
    },
    {
      icon: Brain,
      title: "Memory Care",
      description:
        "Specialized care for residents with Alzheimer's, dementia, and other memory-related conditions.",
      features: [
        "Personalized care plans tailored to each resident’s cognitive and physical abilities",
        "Behavior management and redirection techniques to ensure comfort and safety. Specialized memory-enhancing activities and therapies (music therapy, reminiscence therapy, sensory stimulation, etc.)",
        "Specialized memory-enhancing activities and therapies (music therapy, reminiscence therapy, sensory stimulation, etc.)",
        "Sensory-based activities that engage touch, sound, and scent",
        "Simplified art and craft projects for self-expression and confidence",
        "Small group or one-on-one engagement for residents who benefit from personalized attention",
      ],
    },
    {
      icon: Dumbbell,
      title: "Fitness & Wellness",
      description:
        "Physical therapy, exercise programs, and wellness activities designed for seniors.",
      features: [
        "Personalized wellness plans tailored to each resident’s abilities, goals, and health needs",
        "Daily movement and exercise activities such as stretching, Sit and be fit chair, and light strength training",
        "Gentle walking groups and outdoor activities to enjoy the fresh air and sunshine (weather permitting)",
        "Cognitive and memory-boosting games to support mental sharpness and focus",
        "Relaxation and mindfulness sessions that reduce stress and promote calm",
      ],
    },
    {
      icon: Users,
      title: "Social Activities",
      description:
        "Engaging recreational and social programs to keep residents active and connected.",
      features: [
        "Daily engagement activities, including games and arts",
        "Movie nights, sing-alongs, storytelling sessions, gardening and outdoor relaxation time",
        "Special occasion celebration such as holidays, birthdays, and special milestones",
        "Cognitive activities to promote mental sharpness (puzzles, memory games, brain exercises)",
        "Spiritual and faith-based gatherings for those who wish to participate",
      ],
    },
  ];

  const additionalServices = [
    {
      icon: Car,
      title: "Resident Involvement",
      description:
        "Our residents participate in planning menus, engagement activities, outings, and suggestions for their care choice and style. Residents at Almond Tree are living their life fully. It is basic human nature to accept care and comfort if they are given options and choices.",
    },
    {
      icon: Home,
      title: "Honor Resident ability and preference",
      description:
        "We believe that overall well-being comes from caring for the body, mind, and spirit. Our fitness and wellness programs are designed to help residents stay active, engaged, and independent while honoring individual abilities and preferences.",
    },
    {
      icon: Calendar,
      title: "Wellness first approach ",
      description:
        "At Almond Tree, we take a holistic approach to wellness—celebrating small victories, encouraging independence, and supporting each resident’s journey toward a healthier, happier life.",
    },
    {
      icon: Pill,
      title: "Occupied Resident",
      description:
        "At Almond Tree, we believe that staying socially active and emotionally connected is just as important as physical health. Our team works with residents and families to ensure every activity reflects personal interests, abilities, and lifelong passions.",
    },
    {
      icon: Bath,
      title: "Comprehensive in-home support",
      description:
        "We provide comprehensive in-home support, including nursing services, physical, occupational, and speech therapy, as well as personal training. Residents have access to durable medical equipment as needed—such as oxygen, wheelchairs, and walkers—and benefit from in-home podiatry, dental, and hair care services. Our team also coordinates appointments and assists with scheduling, as well as accompanying residents to their medical and personal visits.",
    },
    {
      icon: Shield,
      title: "Emergency Response",
      description:
        "24/7 emergency call systems and rapid response protocols for all residents.",
    },
  ];

  const carelevels = [
    // {
    //   title: 'Independent Living',
    //   description: 'For active seniors who want maintenance-free living with access to services as needed.',
    //   features: [
    //     'Private apartments',
    //     'Housekeeping services',
    //     'Social activities',
    //     'Dining options',
    //     'Transportation',
    //     'Emergency response'
    //   ]
    // },
    {
      title: "Assisted Living",
      description:
        "Personalized care and support while maintaining independence and dignity.",
      features: [
        "Private or semi-private furnished rooms",
        "24/7 caregiving and safety monitoring",
        "Medication management and health support",
        "Social, recreational, and wellness activities",
      ],
    },
    {
      title: "Memory Care",
      description:
        "Specialized care in secure environments for residents with memory impairments.",
      features: [
        "Secure, safe environment",
        "Cognitive stimulation programs",
        "Specialized staff training",
        "Structured daily routines",
      ],
    },
    // {
    //   title: 'Skilled Nursing',
    //   description: 'Comprehensive medical care and rehabilitation services with 24/7 nursing staff.',
    //   features: [
    //     '24/7 skilled nursing',
    //     'Physical therapy',
    //     'Occupational therapy',
    //     'Speech therapy',
    //     'Medical management',
    //     'Post-hospital care'
    //   ]
    // }
  ];

  return (
    <div className="pt-8" id="services">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 to-green-50 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Comprehensive Care Services
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              At Almond Tree Senior Care, we qualify our residents and family
              members to ensure we are aligned in values and commitments. We are
              a choice for families who are committed to a positive living
              experience and value their loved one's continued health
              restoration.
            </p>
          </div>
        </div>
      </section>

      {/* Main Services */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Core Services
            </h2>
            <p className="text-xl text-gray-600 max-w-7xl mx-auto">
              Resident focus, personalized care, family interaction,
              professional relationships, and capable staff nurtured by Ms.
              Idnani's passion for her residents… Almond Tree Senior Care is
              life with purpose.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300"
              >
                <div className="flex items-center mb-6">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <service.icon className="h-6 w-6 text-primary-green" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {service.title}
                  </h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <li
                      key={featureIndex}
                      className="flex items-center text-gray-700"
                    >
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Care Levels */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Levels of Care
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              We provide a full continuum of care options to meet changing needs
              while allowing residents to age in place within our community.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {carelevels.map((level, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {level.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {level.description}
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {level.features.map((feature, featureIndex) => (
                    <div
                      key={featureIndex}
                      className="flex items-center text-gray-700"
                    >
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-3 flex-shrink-0"></div>
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Additional Services
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Beyond our core care services, we offer a range of amenities and
              support services to enhance daily life and provide complete peace
              of mind.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 p-6 bg-gray-50 rounded-lg"
              >
                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <service.icon className="h-5 w-5 text-green-600" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Information */}
      <section className="py-20 bg-primary-green text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">Transparent Pricing</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            We believe in transparent, all-inclusive pricing with no hidden
            fees. Contact us for a personalized care plan and pricing
            information.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white bg-opacity-10 rounded-lg p-6">
              <h3 className="text-2xl font-bold mb-4">What's Included</h3>
              <ul className="text-left space-y-2 opacity-90">
                <li>• All meals and snacks</li>
                <li>• Utilities and WiFi</li>
                <li>• Housekeeping services</li>
                <li>• Social activities</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 rounded-lg p-6">
              <h3 className="text-2xl font-bold mb-4">Care Services</h3>
              <ul className="text-left space-y-2 opacity-90">
                <li>• Personal care assistance</li>
                <li>• Medication management</li>
                <li>• 24/7 nursing support</li>
                <li>• Healthcare coordination</li>
              </ul>
            </div>
            <div className="bg-white bg-opacity-10 rounded-lg p-6">
              <h3 className="text-2xl font-bold mb-4">Amenities</h3>
              <ul className="text-left space-y-2 opacity-90">
                <li>• Transportation services</li>
                <li>• Fitness and wellness</li>
                <li>• Emergency response</li>
                <li>• Family support</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
